





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Ability } from '@/types/Ability'
import { formatDateYYYYMMDD } from '@/utils/helpers'

@Component({
    computed: {

    },
    components: {
        'font-awesome-icon': FontAwesomeIcon
    }
})

export default class PopupLivraisonFournitures extends Vue {
    @Prop() showPopup: any

    Ability = Ability
    session_en_cours: any = null
    start_at: any = null
    end_at: any = null

    @Watch('showPopup')
    initRegles () {
        this.session_en_cours = this.$store.state.session.sessions.find((s: any) => s.id === this.$store.getters['auth/user_session_id'])
        if (this.session_en_cours.livraison_start_at) {
            this.start_at = formatDateYYYYMMDD(this.session_en_cours.livraison_start_at)
            this.end_at = formatDateYYYYMMDD(this.session_en_cours.livraison_end_at)
        }

    }

    // Ferme la popup de paramétrage des dates de livraison de fournitures
    close_livraison_fournitures () {
        this.$emit('close')
    }

    // Sauvegarder le paramétrage des règles d'organisation
    save_dates_livraison () {
        const payload = {
            livraisons: 1,
            session_id: this.session_en_cours.id,
            livraison_start_at: this.start_at,
            livraison_end_at: this.end_at
        }
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
        this.$store.dispatch('session/updateSessionPlages', payload).then(() => {
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Enregistrement terminé !', succesToaster)
            this.close_livraison_fournitures()
        })
    }
}
